<template>
    <m-filter text="Status" :popup.sync="popup" :filtered="filtered">
        <ul class="list-none overflow-scroll" style="max-height: 180px">
            <li class="p-1 pl-8 cursor-pointer hover_bg-primary-200" @click="select(null)">None</li>
            <li class="p-1 pl-8 cursor-pointer hover_bg-primary-200" v-for="(item, index) in status"
                :class="{'bg-primary-200': value && value.id == item.id}" @click="select(item)">{{ item.value }}
            </li>
        </ul>
    </m-filter>
</template>

<script>
export default {
    props: {
        value: Object
    },
    data: () => ({
        status: [
            {
                id: 0,
                value: "Pending"
            },
            {
                id: 1,
                value: "Error"
            },
            {
                id: 2,
                value: "Cancelled"
            },
            {
                id: 3,
                value: "Completed"
            },
            {
                id: 4,
                value: "Failed"
            }
        ],
        popup: false
    }),
    methods: {
        select(s) {
            this.$emit("input", s);
            this.popup = false;
        }
    },
    computed: {
        filtered() {
            if (!this.value) {
                return ''
            }
            return this.value.value
        }
    }
};
</script>

